/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Error_Remove_ChildInputs */



/**
* | output |
* | --- |
* | "Couldn't remove the child league." |
*
* @param {League_Error_Remove_ChildInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_error_remove_child = /** @type {((inputs?: League_Error_Remove_ChildInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Error_Remove_ChildInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de retirer la ligue enfant.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo eliminar la liga hija.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível remover a liga filha.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile rimuovere il campionato figlio.")
	return /** @type {LocalizedString} */ ("Couldn't remove the child league.")
});